module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clearfix m-t-md c-3-1-wrp"
  }, _vm._l((_vm.favorList), function(f) {
    return _c('div', {
      staticClass: "c-3-1 m-b-md b-gray-1 hp-item-6",
      on: {
        "click": function($event) {
          return _vm.goToCase(f.id)
        }
      }
    }, [_vm._v("\n      " + _vm._s( /** use background for image */ ) + "\n      "), _c('div', {
      staticClass: "clearfix m-a img-c-div h-44",
      style: ({
        backgroundImage: 'url(' + f.coverImgUrl + ')'
      })
    }), _vm._v(" "), (f.isFavored) ? _c('div', {
      staticClass: "collect-heat text-center",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.unfavor(f)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-heart heart-pink"
    }), _vm._v(" "), _c('span', {
      staticClass: "gray-1 text-medium"
    }, [_vm._v(_vm._s(f.favorNum))])]) : _vm._e(), _vm._v(" "), (!f.isFavored) ? _c('div', {
      staticClass: "collect-heat text-center"
    }, [_c('i', {
      staticClass: "fa fa-heart-o"
    }), _vm._v(" "), _c('span', {
      staticClass: "gray-1 text-medium"
    }, [_vm._v(_vm._s(f.favorNum))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "m-a b-gray-1 p-a h-p-item-c"
    }, [_c('div', {
      staticClass: "text-price m-b-15"
    }, [_c('span', {
      staticClass: "f-6"
    }, [_c('span', [_vm._v(_vm._s(f.shopInfo && f.shopInfo.cityName ? f.shopInfo && f.shopInfo.cityName : '北京'))]), _vm._v("｜" + _vm._s(f.title))]), _vm._v(" "), ((f.shopInfo && f.shopInfo.name) !== null && (f.shopInfo && f.shopInfo.name) !== undefined) ? _c('span', {
      staticClass: "f-7"
    }, [_vm._v("－" + _vm._s(f.shopInfo && f.shopInfo.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "gray-1 text-small"
    }, [_c('div', {
      staticClass: "text-elli"
    }, [_vm._v(_vm._s(f.description))])])])])
  }), 0), _vm._v(" "), _c('pagination', {
    attrs: {
      "pagination": _vm.pagination,
      "callback": _vm.loadData,
      "options": _vm.paginationOptions
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "b-gray-1 filter-wrp m-t-md m-b-20"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "gray-4 pull-left f1"
  }, [_vm._v("我的收藏：")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-169b5fae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Collect.vue
// module id = 597
// module chunks = 1